// Copyright (c) 2018 Deere & Company

import {translate} from '../../../shared/services/translation-service';

export const getPipProductSearchColumns = () => ({
    listColumns: [
        {
            id: 'pin',
            key: translate('PIN')
        },
        {
            id: 'model',
            key: translate('MODEL')
        },
        {
            id: 'customer',
            key: translate('CUSTOMER')
        },
        {
            id: 'pipType',
            key: translate('PIP_TYPE')
        },
        {
            id: 'metric',
            key: translate('METRIC')
        },
        {
            id: 'pip',
            key: translate('PIP')
        },
        {
            id: 'participant',
            key: translate('PARTICIPANT')
        },
        {
            id: 'pipStatus',
            key: translate('PIP_STATUS')
        },
        {
            id: 'completionStatus',
            key: translate('COMPLETION_STATUS')
        },
        {
            id: 'leadAccount',
            key: translate('LEAD_ACCOUNT')
        },
        {
            id: 'responsibleAccount',
            key: translate('RESPONSIBLE_ACCOUNT')
        },
        {
            id: 'expires',
            key: translate('EXPIRES')
        },
        {
            id: 'terminates',
            key: translate('TERMINATES')
        },
        {
            id: 'completed',
            key: translate('COMPLETED')
        },
        {
            id: 'dtacSolution',
            key: translate('DTAC_SOLUTION')
        },
        {
            id: 'daysRemaining',
            key: translate('DAYS_REMAINING')
        },
        {
            id: 'comments',
            key: translate('COMMENTS')
        }
    ],
    listId: 'pipProductSearch'
});



// WEBPACK FOOTER //
// ./src/pip/pip-search/services/pip-product-search-excel-columns.js